import { Button, Flex, Typography } from '@aloft/toolkit-sui';

import { WarningTooltipIcon } from '../gridHelpers/WarningTooltipIcon.tsx';

type HiddenCompsWarningToastProps = {
  count: number;
  changedFilterLabels: string[];
  onDismiss: () => void;
};

export const HiddenCompsWarningToast = ({
  count,
  changedFilterLabels,
  onDismiss,
}: HiddenCompsWarningToastProps) => {
  const featuresPrefix =
    changedFilterLabels.length > 0 ? `${changedFilterLabels.join(', ')} ` : '';

  return (
    <Flex
      position="absolute"
      top="12px"
      right="12px"
      zIndex={10}
      width="320px"
      maxWidth="320px"
      backgroundColor="alertWarningLight"
      borderColor="statusWarning"
      borderWidth="1px"
      borderStyle="solid"
      borderRadius="8px"
      padding="8px 11px"
      alignItems="center"
      gap="9px"
      boxShadow="0px 0px 4px 0px rgba(0,0,0,0.04), 0px 4px 8px 0px rgba(0,0,0,0.06)"
    >
      <WarningTooltipIcon size={28} />
      <Flex flexDirection="column" gap="4px" minWidth={0} flex={1}>
        <Typography variant="h4">Current filters are hiding {count} comps</Typography>
        <Typography variant="body2">
          The {featuresPrefix}filters may be eliminating suitable comparables. Adjust or remove the
          parameters to view hidden comparables.
        </Typography>
      </Flex>
      <Button variant="inlineSecondary" icon="close" text="" size="sm" onClick={onDismiss} />
    </Flex>
  );
};
